'use client';

import classNames from 'classnames';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { PropsWithClassname } from '@/app/types';
import { formatPriceInCents } from '@/app/utils/formatting';

import Avatar from '@/app/components/Avatar/Avatar';

interface DonationRecordProps extends PropsWithClassname {
  id: string;
  username: string;
  date: Date;
  amountInCents: number;
  avatarUrl?: string;
  message?: string;
}

const DonationRecord = ({ username, date, amountInCents, avatarUrl, message, className }: DonationRecordProps) => {
  const { t } = useTranslation();
  const [isTimeVisible, setIsTimeVisible] = useState(false);

  // Workaround for hydration errors
  useEffect(() => {
    setIsTimeVisible(true);
  }, []);

  return (
    <div className={classNames(className, 'flex mb-[32px]')}>
      <Avatar imageUrl={avatarUrl} placeholderText={username} className="mr-[16px]" />
      <div>
        <p>{username}</p>
        <div className="flex">
          <span className="text-primary-mid">{formatPriceInCents(amountInCents)}</span>
          <span className="px-[8px]">•</span>
          {isTimeVisible && <span className="text-nowrap">{format(date, t('dateTimeFormat'))}</span>}
        </div>
        {!!message && (
          <div className="bg-secondary-light rounded mt-[16px] px-[24px] py-[16px] break-words">{message}</div>
        )}
      </div>
    </div>
  );
};

export default DonationRecord;
